import { action, observable } from 'mobx';
import { TBrand, TTheme } from 'telia-front-react';

class Config {
  @observable accessor eidAuthDomain: string = '';
  @observable accessor teliaWebUrl: string = '';
  @observable accessor selfServiceUrl: string = '';
  @observable accessor diilSelfServiceUrl: string = '';
  @observable accessor superUrl: string = '';
  @observable accessor env: string = '';
  @observable accessor apiUrl: string = '';
  @observable accessor frontendUrl: string = '';
  @observable accessor isModule: boolean = false;
  @observable accessor brand: TBrand | null = null;
  @observable accessor theme: TTheme | null = null;
  public initialized: boolean = false;

  @action.bound
  public initialize(initialConfig: InitialConfig) {
    this.eidAuthDomain = initialConfig.eidAuthDomain;
    this.teliaWebUrl = initialConfig.teliaWebUrl;
    this.selfServiceUrl = initialConfig.selfServiceUrl;
    this.diilSelfServiceUrl = initialConfig.diilSelfServiceUrl;
    this.superUrl = initialConfig.superUrl;
    this.env = initialConfig.env;
    this.initialized = true;
  }

  @action.bound
  public setFrontendUrl(feUrl: string) {
    this.frontendUrl = feUrl;
  }

  @action.bound
  public setApiUrl(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  @action.bound
  public setIsModule(isModule: boolean) {
    this.isModule = isModule;
  }

  @action.bound
  public setBrand(brand: string) {
    this.brand = brand as TBrand | null;
  }

  @action.bound
  public setTheme(theme: string) {
    this.theme = theme as TTheme | null;
  }
}

export default new Config();
